import { createApp } from 'vue';
import { default as orderService } from './order-service';
import { currency } from './../formatting/currency';

for (let block of document.querySelectorAll('.purchase-block')) {
    let app = createApp({
        data() {
            return {
                product: {},
                total: 0,
                quantity: null,
                busy: false
            }
        },
        mounted() {
            Object.assign(this.product, this.$refs.quantity.dataset);
            this.product.price = Number(this.product.price);

            this.total = this.product.price;
        },
        watch: {
            quantity() {
                this.total = (this.quantity || 1) * this.product.price;
            }
        },
        methods: {
            currency,
            addToCart() {
                if (this.$refs.quantity.validity.valid === false) {
                    return;
                }

                this.busy = true;
                orderService
                    .addToCart(this.product.sku, this.quantity || 1, this.total, this.product)
                    .then(() => this.busy = false);
            },
            toggleFavorite() {
                if (Array.from(this.$refs.star.classList).filter(x => x === "bi-star").length) {
                    this.$refs.star.classList.remove("bi-star");
                    this.$refs.star.classList.add("bi-star-fill");
                } else {
                    this.$refs.star.classList.remove("bi-star-fill");
                    this.$refs.star.classList.add("bi-star");
                }

                window.fetch('/nettbutikk/api/togglefavorite?sku=' + this.product.sku);
            }
        }
    });

    app.mount(block);
}

